<template>
  <div id="scaleQuestionsView">
    <h1>{{ $t('privatePage.scaleQuestions_header') }}</h1>
    <question-editor-bp v-if="questionFormat(1)"
                        :questionCollection="questionCollection"
                        :languages="languages"
                        :busyFetching="busyFetching"
                        v-on:formSubmitted="formSubmitted"
                        v-on:errorCaught="errorCaught"
                        v-on:addQuestion="addQuestion"
                        v-on:deleteQuestion="deleteQuestion">
    </question-editor-bp>
    <question-editor-gverb v-else-if="questionFormat(2)"
                        :questionCollection="questionCollection"
                        :languages="languages"
                        :busyFetching="busyFetching"
                        v-on:formSubmitted="formSubmitted"
                        v-on:errorCaught="errorCaught"
                        v-on:addQuestion="addQuestion"
                        v-on:deleteQuestion="deleteQuestion">
    </question-editor-gverb>
    <question-editor-gnum v-else-if="questionFormat(3)"
                          :questionCollection="questionCollection"
                          :busyFetching="busyFetching"
                          v-on:formSubmitted="formSubmitted"
                          v-on:errorCaught="errorCaught"
                          v-on:addQuestion="addQuestion"
                          v-on:deleteQuestion="deleteQuestion">
    </question-editor-gnum>
    <question-editor-gfair v-else-if="questionFormat(4)"
                          :currentScaleIsRandomLogicTest="currentScaleIsRandomLogicTest === 'true'"
                          :questionCollection="questionCollection"
                          :busyFetching="busyFetching"
                          v-on:formSubmitted="formSubmitted"
                          v-on:errorCaught="errorCaught"
                          v-on:addQuestion="addQuestion"
                          v-on:deleteQuestion="deleteQuestion">
    </question-editor-gfair>
    <question-editor-gfig v-else-if="questionFormat(5)"
                          :currentScaleIsRandomLogicTest="currentScaleIsRandomLogicTest === 'true'"
                          :questionCollection="questionCollection"
                          :busyFetching="busyFetching"
                          v-on:formSubmitted="formSubmitted"
                          v-on:errorCaught="errorCaught"
                          v-on:addQuestion="addQuestion"
                          v-on:deleteQuestion="deleteQuestion">
    </question-editor-gfig>
    <question-editor-tso v-else-if="questionFormat(6)"
                        :questionCollection="questionCollection"
                        :languages="languages"
                        :busyFetching="busyFetching"
                        v-on:formSubmitted="formSubmitted"
                        v-on:errorCaught="errorCaught"
                        v-on:addQuestion="addQuestion"
                        v-on:deleteQuestion="deleteQuestion">
    </question-editor-tso>
    <question-editor-ledord v-else-if="questionFormat(8)"
                        :questionCollection="questionCollection"
                        :languages="languages"
                        :busyFetching="busyFetching"
                        v-on:formSubmitted="formSubmitted"
                        v-on:errorCaught="errorCaught"
                        v-on:addQuestion="addQuestion"
                        v-on:deleteQuestion="deleteQuestion">
    </question-editor-ledord>

    <b-form-group>
      <b-alert v-model="alerts.countdown"
              dismissible
              :variant="alerts.variant"
              @closed="alerts.countdown=0"
              @close-count-down="countDownChanged">
        {{alerts.message}}
      </b-alert>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import QuestionEditorBp from '../../components/scales/questions/questioneditorbp'
import QuestionEditorGverb from '../../components/scales/questions/questioneditorgverb'
import QuestionEditorGnum from '../../components/scales/questions/questioneditorgnum'
import QuestionEditorGfair from '../../components/scales/questions/questioneditorgfair'
import QuestionEditorGfig from '../../components/scales/questions/questioneditorgfig'
import QuestionEditorTso from '../../components/scales/questions/questioneditortso'
import QuestionEditorLedord from '../../components/scales/questions/questioneditorledord'
import editorFuncs from '../../components/scales/questions/questioneditorfuncs'

export default {
  components: {
    QuestionEditorBp,
    QuestionEditorGverb,
    QuestionEditorGnum,
    QuestionEditorGfair,
    QuestionEditorGfig,
    QuestionEditorTso,
    QuestionEditorLedord
  },
  computed: {
    ...mapGetters(['selectedCulture', 'languages']),
    ...mapGetters('scalesModule', ['questionCollection'])
  },
  methods: {
    ...mapActions('scalesModule', {
      getQuestions: 'getQuestions',
      saveQuestions: 'saveQuestions'
    }),
    questionFormat: function(format) {
      if (`${format}` === this.currentScaleQuestionFormatId) {
        return true
      }
      return false
    },
    countDownChanged: function(dismissCountDown) {
      this.alerts.countdown = dismissCountDown
    },
    formSubmitted: function(data) {
      data.questionFormatId = this.currentScaleQuestionFormatId
      data.defaultLanguageId = this.selectedCulture.languageId

      this.saveQuestions({
        scaleId: this.currentScaleId,
        data: data
      })
        .then(() => {
          this.showSubmitMessage()
        })
        .catch(error => {
          this.showErrorMessage(error)
        })
    },
    errorCaught: function(message) {
      this.showErrorMessage(message)
    },
    showSubmitMessage: function() {
      this.showSuccessMessage(this.$t('save_ok_feedback'))
    },
    showMessage: function(message) {
      this.alerts.message = message
      this.alerts.countdown = this.alerts.dismissSecs
      this.alerts.variant = 'info'
    },
    showErrorMessage: function(message) {
      this.alerts.message = message
      this.alerts.countdown = this.alerts.dismissSecs
      this.alerts.variant = 'danger'
    },
    showSuccessMessage: function(message) {
      this.alerts.message = message
      this.alerts.countdown = this.alerts.dismissSecs
      this.alerts.variant = 'success'
    },
    addQuestion(questions) {
      editorFuncs.addQuestion(questions)
    },
    deleteQuestion(index) {
      this.questionCollection.forEach(collection => {
        if (collection.isDefaultLanguage) {
          editorFuncs.deleteObjectFromCollection(collection.questions, index)
        }
      })
    }
  },
  data() {
    return {
      alerts: {
        dismissSecs: 3,
        countdown: 0,
        message: '',
        variant: 'warning'
      },
      imageCount: 0,
      busyFetching: false
    }
  },
  props: {
    currentScaleId: '',
    currentScaleQuestionFormatId: '',
    currentScaleIsRandomLogicTest: ''
  },
  created() {
    if (this.currentScaleId) {
      this.busyFetching = true
      this.getQuestions({
        scaleId: this.currentScaleId,
        languageId: this.selectedCulture.languageId
      }).then(() => {
        this.busyFetching = false
      })
    }
  }
}
</script>
